import type { LocationQuery, RouteLocationRaw } from 'vue-router'

import { ROUTE_NOT_FOUND } from './names'
import { internalPath } from './return-to'

/**
 * The 404 page shows the address that was not found (2026-11 redesign; legacy dropped it, wp/shell §4.1): every
 * redirect to `error-404` carries the opened path as `?from=`. The page reads it back through `missedPath`, so only an
 * internal path is ever shown.
 */
export const MISSED_QUERY = 'from'

/** The 404 location for `to`; its full path rides along when it is an internal path (never the 404 page's own). */
export function notFoundLocation(to: { fullPath?: string }): RouteLocationRaw {
  const path = internalPath(to.fullPath)
  if (!path || path.startsWith('/error-404')) return { name: ROUTE_NOT_FOUND }
  return { name: ROUTE_NOT_FOUND, query: { [MISSED_QUERY]: path } }
}

/** The path the 404 page was given, when it is an internal path; else `null`. */
export function missedPath(query: LocationQuery): string | null {
  return internalPath(query[MISSED_QUERY])
}
